<template>
  <div class="background d-flex align-items-center pb-5">
    <b-container>
      <div class="pt-3">
        <!-- <h2 class="text-dark pt-5">Meet the experts</h2> -->
      </div>
      <b-row class="justify-content-center">
        <b-col sm="10">
          <div class="ml-2 ml-md-3">
            <h1 class="text-dark ml-5 mr-5 pr-xl-4 pl-xl-4 pr-md-5 pl-md-5">
              Enhance your skills in...
            </h1>
          </div>
          <div class="mr-3 ml-3 mr-sm-0 ml-sm-0">
            <Gallery
              class="gallery ml-5 mr-5 pr-xl-4 pl-xl-4 pr-md-5 pl-md-5"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>
import Gallery from "./Gallery.vue";

export default {
  components: {
    Gallery,
  },
};
</script>

<style scoped>
.background {
  height: 1173px;
  background: url("../../static/buildings-vegetation_1.png");
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  position: relative;
}
@media screen and (max-width: 1000px) {
  .background {
    height: 100%;
  }
}

.gallery {
  z-index: 999;
}
</style>


// WEBPACK FOOTER //
// src/components/MeetTheExperts.vue